export default __webpack_public_path__ + "static/media/rising_badge.473c7cbd.png";